import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
import ReferEarnForm from './ReferEarnForm';
import { getReferEarnRequest } from '../Dashboard/dashboardAction';
import { REFERRAL_URL } from '../../../utils/urls';
import { useHistory } from 'react-router-dom';
import { logFirebaseEvent } from '../firebase';
import { P2P_COPY_LINK_BTN, P2P_REFER_EARN_VIEW } from '../firebase/constant';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import {
  getAuthToken,
  getMobileNo,
  getUserDetails,
} from '../../../utils/localStorage';
import jwt from 'jwt-decode';

const ReferEarn = () => {
  const history = useHistory();
  const { referEarnError, referEarnData } = useSelector(
    (state: any) => state.dashboard
  );
  const [referUrl, setReferUrl] = useState<any>('');
  const [user, setUser] = useState<any>(null);
  useEffect(() => {
    logFirebaseEvent(P2P_REFER_EARN_VIEW);
    const token: any = getAuthToken();
    const decoded_token = jwt(token);
    setUser(decoded_token); // decode your token here
    document.title = 'stashearn - refer-earn';
  }, []);

  useEffect(() => {
    if (user !== null) {
      setReferUrl(REFERRAL_URL + user?.referral_code);
    }
  }, [user]);

  const [referLink, setReferLink] = React.useState(false);
  const [referLinkCode, setReferLinkCode] = React.useState(false);

  const onClickCopy = () => {
    logFirebaseEvent(P2P_COPY_LINK_BTN);
    navigator.clipboard.writeText(REFERRAL_URL + user?.referral_code);
    setReferLink(!referLink);
    if ((window as any).Android) {
      (window as any).Android.copyToClipboard(
        REFERRAL_URL + user?.referral_code
      );
    }
  };

  const onClickCopyReferaCode = () => {
    logFirebaseEvent(P2P_COPY_LINK_BTN);
    navigator.clipboard.writeText(user?.referral_code);
    setReferLinkCode(!referLinkCode);
    if ((window as any).Android) {
      (window as any).Android.copyToClipboard(
       user?.referral_code
      );
    }
  };


  const handleLogin = () => {
    history.push({ pathname: '/' });
  };

  const handleReferNow = () => {
    const user = JSON.parse(getUserDetails());
  };

  return (
    <>
      <BackgroundTheme>
        <Card className='redBorder'>
          <CardContent>
            <ReferEarnForm
              referEarnData={referEarnData}
              referEarnError={referEarnError}
              onClickCopy={onClickCopy}
              onClickCopyReferaCode={onClickCopyReferaCode}
              referLink={referLink}
              handleLogin={handleLogin}
              handleReferNow={handleReferNow}
              referLinkCode={referLinkCode}
              referUrl={referUrl}
              user={user?.full_name}
              referalCode = {user?.referral_code}
            />
          </CardContent>
        </Card>
      </BackgroundTheme>
    </>
  );
};

export default ReferEarn;
